export type PjAgradaStatus = 'ATIVO' | 'INATIVO' | 'NAO_PREENCHIDO' | 'NAO_CONCLUIDO'

export type PjAgradaCadastroInvite = {
  id: string
  url: string | null
  expiresAt: string
  isExpired: boolean
}

export type PjAgrada = {
  id: string
  nomeCompleto: string
  email?: string | null
  telefone: string
  cpf?: string | null
  cnpj?: string | null
  razaoSocial?: string | null
  cep?: string | null
  logradouro?: string | null
  numero?: string | null
  complemento?: string | null
  bairro?: string | null
  cidade?: string | null
  uf?: string | null
  bancoNome?: string | null
  bancoAgencia?: string | null
  bancoConta?: string | null
  bancoTipoConta?: 'corrente' | 'poupanca' | null
  pixChave?: string | null
  areaAtuacao?: string | null
  dataInicioContrato?: string | null
  status: PjAgradaStatus
  observacoes?: string | null
  portalUserId?: string | null
  createdAt: string
  updatedAt: string
  cadastroInvite?: PjAgradaCadastroInvite | null
}

export type PjAgradaFormData = {
  id?: string
  nomeCompleto: string
  email: string
  telefone: string
  cpf: string
  cnpj: string
  razaoSocial: string
  cep: string
  logradouro: string
  numero: string
  complemento: string
  bairro: string
  cidade: string
  uf: string
  bancoNome: string
  bancoAgencia: string
  bancoConta: string
  bancoTipoConta: '' | 'corrente' | 'poupanca'
  pixChave: string
  areaAtuacao: string
  dataInicioContrato: string
  status: PjAgradaStatus
  observacoes: string
  portalUserId: string
}

export const EMPTY_PJ_AGRADA_FORM: PjAgradaFormData = {
  nomeCompleto: '',
  email: '',
  telefone: '',
  cpf: '',
  cnpj: '',
  razaoSocial: '',
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  uf: '',
  bancoNome: '',
  bancoAgencia: '',
  bancoConta: '',
  bancoTipoConta: '',
  pixChave: '',
  areaAtuacao: '',
  dataInicioContrato: '',
  status: 'ATIVO',
  observacoes: '',
  portalUserId: '',
}
